import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/node/deploy/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/node/deploy/src/app/scientific-foundation/components/ResearchDatabase.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/node/deploy/src/app/scientific-foundation/components/TechnicalSpecifications.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/node/deploy/src/components/common/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/node/deploy/src/components/ui/AppIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/node/deploy/src/components/ui/AppImage.tsx");
